import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dispatch-tracking',
  templateUrl: './dispatch-tracking.component.html',
  styleUrls: ['./dispatch-tracking.component.css']
})
export class DispatchTrackingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
